module.exports = __webpack_public_path__ + "static/media/bbb-accredited.240eb926.png";